import { useEffect, useState } from 'react';
import { NAV_STATUS_OPTIONS } from '../../constants/navios';
import { ParseDecimalInput } from '../../utils/format';
import Button from '../ui/Button';
import Input from '../ui/Input';
import Modal from '../ui/Modal';
import Select from '../ui/Select';

// Horário digitado é de Brasília. O Brasil não tem horário de verão desde
// 2019, então o deslocamento é fixo em −03:00.
const BRASILIA_OFFSET = '-03:00';
const toUtcIso = (localValue) => (localValue ? new Date(`${localValue}:00${BRASILIA_OFFSET}`).toISOString() : null);

/**
 * Posição manual (enquanto não há provider AIS). Mesmas regras do worker e do
 * MCP: leitura igual/mais velha que a última, ou com mais de 7 dias, é
 * descartada — a tela avisa o motivo.
 */
const NavioPosicaoModal = ({ isOpen, vessel = null, saving = false, onClose, onSubmit }) => {
    const [lat, setLat] = useState('');
    const [lon, setLon] = useState('');
    const [observedAt, setObservedAt] = useState('');
    const [navStatus, setNavStatus] = useState('underway');
    const [speed, setSpeed] = useState('');
    const [destination, setDestination] = useState('');
    const [etaAis, setEtaAis] = useState('');
    const [reportedSource, setReportedSource] = useState('');

    useEffect(() => {
        if (isOpen) {
            setLat('');
            setLon('');
            setObservedAt('');
            setNavStatus('underway');
            setSpeed('');
            setDestination(vessel?.last_position?.destination || '');
            setEtaAis('');
            setReportedSource('');
        }
    }, [isOpen, vessel]);

    const submit = (event) => {
        event.preventDefault();
        const speedValue = ParseDecimalInput(speed);
        onSubmit({
            lat: ParseDecimalInput(lat),
            lon: ParseDecimalInput(lon),
            observed_at: toUtcIso(observedAt),
            nav_status: navStatus,
            speed_kn: Number.isFinite(speedValue) ? speedValue : null,
            destination: destination.trim() || null,
            eta_ais: toUtcIso(etaAis),
            ...(reportedSource.trim() ? { reported_source: reportedSource.trim() } : {}),
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={`Posição de ${vessel?.name || ''}`}
            size="lg"
            actions={
                <>
                    <Button variant="secondary" onClick={onClose} disabled={saving}>
                        Cancelar
                    </Button>
                    <Button type="submit" form="navio-posicao-form" loading={saving}>
                        Registrar
                    </Button>
                </>
            }
        >
            <form id="navio-posicao-form" className="space-y-4" onSubmit={submit}>
                <div className="grid grid-cols-2 gap-4">
                    <Input
                        label="Latitude"
                        value={lat}
                        onChange={(event) => setLat(event.target.value)}
                        inputMode="decimal"
                        placeholder="-32.2997"
                        hint="Sul negativo"
                        required
                    />
                    <Input
                        label="Longitude"
                        value={lon}
                        onChange={(event) => setLon(event.target.value)}
                        inputMode="decimal"
                        placeholder="-2.1347"
                        hint="Oeste negativo"
                        required
                    />
                </div>
                <Input
                    label="Hora da leitura AIS (Brasília)"
                    type="datetime-local"
                    value={observedAt}
                    onChange={(event) => setObservedAt(event.target.value)}
                    required
                />
                <div className="grid grid-cols-2 gap-4">
                    <Select label="Status" value={navStatus} onChange={(event) => setNavStatus(event.target.value)}>
                        {NAV_STATUS_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </Select>
                    <Input
                        label="Velocidade (kn)"
                        value={speed}
                        onChange={(event) => setSpeed(event.target.value)}
                        inputMode="decimal"
                        placeholder="18,5"
                    />
                </div>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <Input
                        label="Destino (AIS)"
                        value={destination}
                        onChange={(event) => setDestination(event.target.value)}
                        placeholder="SANTOS"
                    />
                    <Input
                        label="ETA do AIS (Brasília)"
                        type="datetime-local"
                        value={etaAis}
                        onChange={(event) => setEtaAis(event.target.value)}
                    />
                </div>
                <Input
                    label="Fonte"
                    value={reportedSource}
                    onChange={(event) => setReportedSource(event.target.value)}
                    placeholder="De onde copiou (ex.: e-mail do agente)"
                />
            </form>
        </Modal>
    );
};

export default NavioPosicaoModal;
